import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { isAdminPortal } from './lib/portal';
import './styles/tokens.css';
import './styles/globals.css';

if (isAdminPortal) {
  document.title = 'STS2 管理终端';
  document.querySelector('link[rel="manifest"]')?.remove();
  const robots = document.createElement('meta');
  robots.name = 'robots';
  robots.content = 'noindex, nofollow, noarchive';
  document.head.appendChild(robots);
}

const legacyRouteMap: Record<string, string> = {
  overview: '/dashboard', insights: '/insights', cards: '/cards', relics: '/relics', encounters: '/encounters',
  coop: '/coop', runs: '/runs', settings: '/settings', 'how-to': '/how-to'
};

if (location.hash.startsWith('#/')) {
  const legacy = location.hash.slice(2);
  let target = legacyRouteMap[legacy];
  const detail = legacy.match(/^(card|relic|encounter)\/(.+)$/);
  if (detail) target = `/${detail[1] === 'card' ? 'cards' : detail[1] === 'relic' ? 'relics' : 'encounters'}/${detail[2]}`;
  if (target) history.replaceState(null, '', `${target}${location.search}`);
}

createRoot(document.getElementById('root')!).render(<StrictMode><ErrorBoundary title="应用暂时无法启动"><BrowserRouter><App /></BrowserRouter></ErrorBoundary></StrictMode>);
